export const MBAPL_FINANCIAL_API = `v1/financial-reporting/mbapl`;
